import { requestData } from './'

export const sendPortfolio = async (data) => {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    if(data[key]){
      formData.append(key, data[key])
    }
  })


  return await requestData(`send.php`, {}, 'POST', formData)
}

export const sendResult = async (data) => {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    formData.append(key, data[key])
  })
  return await requestData(`send.php`, {}, 'POST', formData)
}


// WEBPACK FOOTER //
// ./src/api/messages.js